module.exports = __webpack_public_path__ + "img/earth.2031e2e2.png";